import React from 'react';
import { IconButton, Tooltip, useColorScheme } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ThemeToggleButtonProps {
  className?: string;
}

const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({ className }) => {
  const { t } = useTranslation();
  // https://mui.com/material-ui/customization/dark-mode/#toggling-color-mode
  const { mode, systemMode, setMode } = useColorScheme();
  const effectiveMode = mode === 'system' ? systemMode : mode;
  if (!effectiveMode) {
    return null;
  }

  return (
    <Tooltip title={t(effectiveMode === 'light' ? 'common.theme.switchDark' : 'common.theme.switchLight')}>
      <IconButton
        onClick={ () => setMode(effectiveMode === 'light' ? 'dark' : 'light') }
        className={`theme-toggle-button ${className || ''}`}
        aria-label={t(effectiveMode === 'light' ? 'common.theme.switchDark' : 'common.theme.switchLight')}
        sx={{
          backgroundColor: 'transparent',
          padding: 1,
          transition: 'all var(--transition-speed) var(--transition-easing)',
          '&:hover': {
            backgroundColor: 'action.hover',
          }
        }}
      >
        {effectiveMode === 'light' ? <DarkMode /> : <LightMode />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
